var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('help',{attrs:{"text":_vm.helpText,"title":_vm.helpTitle}}),_c('canvas',{attrs:{"id":"articleDistributionChart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }